import {Table, TableRow} from 'platform/components';

import {type PricelistVersionChangeResponseBody} from '@dms/api/new-vehicle';
import {getNewVehicleEnumLabel} from '@dms/features/new-vehicle';

import {Cell, column, t} from './catalogueUi';
import {PriceWithGross} from './PriceWithGross';
import {useCatalogueVatRate} from './useCatalogueVatRate';

/** Old and new price per repriced item, for an adjustment preview or a pricelist version. */
export function PriceChangesTable(props: {
  changes: PricelistVersionChangeResponseBody[];
  currency: string;
  modelYearId: string;
}) {
  const vatRate = useCatalogueVatRate(props.modelYearId);
  return (
    <Table
      columns={[
        column(t('entity.newVehicle.catalogue.adjustment.item', 'Item')),
        column(t('entity.newVehicle.catalogue.type', 'Type'), {width: '22%'}),
        column(t('entity.newVehicle.catalogue.adjustment.before', 'Before'), {
          width: '20%',
          align: 'right',
        }),
        column(t('entity.newVehicle.catalogue.adjustment.after', 'After'), {
          width: '20%',
          align: 'right',
        }),
      ]}
    >
      {props.changes.map((change) => (
        <TableRow key={`${change.resourceType}-${change.resourceId}`}>
          <Cell>{change.name}</Cell>
          <Cell>{getNewVehicleEnumLabel('adjustmentScope', change.resourceType, t)}</Cell>
          <Cell align="right">
            <PriceWithGross amount={change.before} currency={props.currency} vatRate={vatRate} />
          </Cell>
          <Cell align="right">
            <PriceWithGross amount={change.after} currency={props.currency} vatRate={vatRate} />
          </Cell>
        </TableRow>
      ))}
    </Table>
  );
}
